import api from "../api-backend";
import {reverseFacetData} from "@/utils/utils";

class MaterialService {

    getMaterials = async (page, size, query, sort) => {
        const response = await api.get(`/engine/item?query=${query}&rows=${size}&start=${page}&sort=${sort}`)
        response.data.facet_counts.facet_fields.data = reverseFacetData(response.data.facet_counts.facet_fields.data)
        return {
            'materials': response.data.response.docs,
            'facetes': response.data.facet_counts.facet_fields,
            'facetes_pivot': response.data.facet_counts.facet_pivot,
            'total': response.data.response.numFound
        }
    }

    getMaterial = async (id) => {
        const response = await api.get(`/engine/${id}`)
        return {
            'material': response.data.response.docs[0],
        }
    }
}

export default new MaterialService()
